module.exports = __webpack_public_path__ + "assets/ic-telegram.2e6ca72b.svg";